import FictivSymbol from '~/lib/FictivSymbol'

export const SET_LOADING_DFM_MESSAGE_CREATE = FictivSymbol(
    'SET_LOADING_DFM_MESSAGE_CREATE',
)

export const SET_DFM_MESSAGE_CREATE_SUCCESS = FictivSymbol(
    'SET_DFM_MESSAGE_CREATE_SUCCESS',
)

export const SET_DFM_MESSAGE_CREATE_FAILURE = FictivSymbol(
    'SET_DFM_MESSAGE_CREATE_FAILURE',
)

export const SET_LOADING_DFM_MESSAGE_EDIT = FictivSymbol(
    'SET_LOADING_DFM_MESSAGE_EDIT',
)

export const SET_DFM_MESSAGE_EDIT_SUCCESS = FictivSymbol(
    'SET_DFM_MESSAGE_EDIT_SUCCESS',
)

export const SET_DFM_MESSAGE_EDIT_FAILURE = FictivSymbol(
    'SET_DFM_MESSAGE_EDIT_FAILURE',
)

export const SHOW_DFM_MESSAGE_CREATE_MODAL = FictivSymbol(
    'SHOW_DFM_MESSAGE_CREATE_MODAL',
)
export const HIDE_DFM_MESSAGE_CREATE_MODAL = FictivSymbol(
    'HIDE_DFM_MESSAGE_CREATE_MODAL',
)

export const SHOW_DFM_MESSAGE_EDIT_MODAL = FictivSymbol(
    'SHOW_DFM_MESSAGE_EDIT_MODAL',
)
export const HIDE_DFM_MESSAGE_EDIT_MODAL = FictivSymbol(
    'HIDE_DFM_MESSAGE_EDIT_MODAL',
)
